module.exports = "/_next/static/images/loading_05-f7606b60b2cc2274c715e198ca9f1e54.png";